import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AufgabeErledigtDto } from '@app/dto/aufgabe.erledigt.dto';
import { AufgabePaketDto } from '@app/dto/aufgabepaket.dto';
import { AufgabenService } from '@app/services/aufgaben.service';
import { UserService } from '@app/services/user.service';
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { VorschlagDuplikatDto } from "@app/dto/vorschlagduplikat.dto";
import { VorschlagEswDto } from "@app/dto/vorschlagEsw.dto";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from "@angular/material/paginator";
import { FirmenstandorteService } from "@app/services/firmenstandorte.service";
import { FirmenIndexFirmaDto } from "@app/dto/firmen.index.firma.dto";
import { TableElement }  from "@app/dto/table.element.model";
import { forkJoin, map, Observable } from "rxjs";
import { FirmenstandorteIndexResponseDto } from "@app/dto/firmenstandorte.index.response.dto";
import { FirmenstandorteIndexFirmenstandortDto } from "@app/dto/firmenstandorte.index.firmenstandort.dto";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AufgabeEintragDto } from "@app/dto/aufgabe.eintrag.dto";

declare var window: any;

@Component({
  selector: 'app-aufgabe',
  templateUrl: './aufgabe.component.html',
  styleUrls: ['./aufgabe.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false},
    },
  ],
})
export class AufgabeComponent implements OnInit {

  aufgabeTyp: string = 'Duplikatspruefung';
  aufgabeId: string;
  aufgabeErledigt!: AufgabeErledigtDto;
  currentAufgabe: any;
  currentAufgabePaket: AufgabePaketDto | undefined;
  originalFirmenname!: string;
  firmenId!: string;

  successMsg: Array<string> = [];
  errorMsg:   Array<string> = [];
  rejectMsg!: string;

  aufgabeDataSource: any;
  initAufgabeColumns = [
    {
      name: 'aufgabeText',
      label: 'Aufgabe',
    },
    {
      name: 'aufgabeId',
      label: 'ID',
    },
  ];
  displayedAufgabeColumns = this.initAufgabeColumns.map(col => col.name);

  pruefdatenSource: any;
  tablePruefdatenSource: any;
  initPruefdatenColumns = [
    {
      name: 'firmenname',
      label: 'ZU PRÜFENDER STANDORT',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'beDirectId',
      label: 'beDirectId',
    },
    {
      name: 'source',
      label: 'Quelle',
    },
    {
      name: 'salesforceId',
      label: 'Account-ID',
    },
    {
      name: 'pcAdressnummer',
      label: 'PC-Adr.Nr.',
    },
    {
      name: 'nlCode',
      label: 'NL',
    },

  ];
  displayedPruefdatenColumns = this.initPruefdatenColumns.map(col => col.name);

  duplikateDataSource!: VorschlagDuplikatDto[];
  initDuplikateColumns = [
    {
      name: 'name',
      label: 'Firma',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'beDirectId',
      label: 'beDirectId',
    }
  ]
  displayedDuplikateColumns     = this.initDuplikateColumns.map(col => col.name);
  displayedDuplikateVorschlaegeColumnsWithSelects = [...this.displayedDuplikateColumns, 'selectDuplikatVorschlagCol'];
  duplicateSelected: boolean = false;
  formDuplikat: FormGroup = new FormGroup({
    selectDuplikatVorschlag: new FormControl({}),
  });

  vorschlaegeESWDataSource!: MatTableDataSource<VorschlagEswDto>;
  initESWVorschlaegeColumns = [
    {
      name: 'name',
      label: 'Firma',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'beDirectId',
      label: 'beDirectId',
    }
  ]
  displayedESWVorschlaegeColumns = this.initESWVorschlaegeColumns.map(col => col.name);
  displayedESWVorschlaegeColumnsWithSelects = [...this.displayedESWVorschlaegeColumns, 'selectESWVorschlagCol'];
  eswSelected: boolean = false;
  formESW: FormGroup = new FormGroup({
    selectESWVorschlag: new FormControl({}),
  });

  vorschlaegeFirmenIndexDataSource!: MatTableDataSource<FirmenIndexFirmaDto>;
  initFirmenIndexColumns = [
    {
      name: 'firmenname',
      label: 'Firma',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'beDirectId',
      label: 'beDirectId',
    }
  ]
  displayedFirmenIndexColumns     = this.initFirmenIndexColumns.map(col => col.name);
  displayedFirmenIndexVorschlaegeColumnsWithSelects = [...this.displayedFirmenIndexColumns, 'selectDuplikatVorschlagCol'];

  neuanlageFirmaDataSource!: any;
  initNeuanlageFirmaColumns = [
    {
      name: 'firmenname',
      label: 'Firma',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
    },
    {
      name: 'beDirectId',
      label: 'beDirectId',
    },
  ];
  displayedNeuanlageFirmaColumns = this.initNeuanlageFirmaColumns.map(col => col.name);

  neuanlagePcAdresseDataSource!: any;
  initNeuanlagePcAdresseColumns = [
    {
      name: 'originalFirmenname',
      label: 'Firma',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'pcAdressnummer',
      label: 'PC-Adr.Nr.',
    },
    {
      name: 'nlCode',
      label: 'NL',
    }
  ];
  displayedNeuanlagePcAdresseColumns = this.initNeuanlagePcAdresseColumns.map(col => col.name);

  filterString: string;
  eswSearchString: string | undefined;
  eswSearchResult: any;

  firmenIndexSearchCriteriaSearch: string | undefined;
  firmenIndexSearchCriteriaSearchField: string | undefined;
  firmenIndexResultListLength: number = 0;

  eswSucheForm: FormGroup = new FormGroup({
    firmenname:   new FormControl(''),
    plz:          new FormControl(''),
    ort:          new FormControl(''),
    strasse:      new FormControl(''),
  });

  public editStandortDatenForm = new FormGroup({
    firmenname:           new FormControl('', [Validators.required]),
    strasseUndHausnummer: new FormControl('', [Validators.required]),
    plz:                  new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("^[0-9]*$")]),
    ort:                  new FormControl('', [Validators.required])
  });

  public firmenIndexSucheForm: FormGroup = new FormGroup({
    firma:          new FormControl(''),
    firmenstandort: new FormControl(''),
  });

  firmaFieldsString: string = 'firmenname,firmenId,crefonummer,firmenstandorteId';
  firmenstandortFieldsString: string = 'strasseUndHausnummer,plz,ort,beDirectId';

  useExactSearchFirma: boolean = true;
  searchSpecialCharacterFirma: string = this.useExactSearchFirma ? '*' : '~';
  searchModeFirma: string = this.useExactSearchFirma ? 'all' : 'any';
  queryTypeFirma: string = this.useExactSearchFirma ? 'simple' : 'full';

  useExactSearchFirmenstandort: boolean = true;
  searchSpecialCharacterFirmenstandort: string = this.useExactSearchFirmenstandort ? '*' : '~';
  searchModeFirmenstandort: string = this.useExactSearchFirmenstandort ? 'all' : 'any';
  queryTypeFirmenstandort: string = this.useExactSearchFirmenstandort ? 'simple' : 'full';

  firmaOrderByString: string = 'orderColSuche,plz'; // default asc
  firmenstandortOrderByString: string = 'plz,orderColSuche'; // default asc

  showAlsoDeletedElements: boolean = false;

  successModal: any;
  errorModal: any;
  rejectModal: any;
  eswSearchModal: any;
  firmenIndexSearchModal: any;
  editStandortDatenModal: any;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator | null;
  @ViewChild('paginatorFI') paginatorFI!: MatPaginator | null;

  constructor(
      private readonly userService: UserService,
      public router: Router,
      private route: ActivatedRoute,
      private aufgabenService: AufgabenService,
      private firmenstandorteService: FirmenstandorteService,
  ) {

    this.filterString = `istGeloescht eq ${this.showAlsoDeletedElements}`;

    if (this.route.snapshot.url[1].path && this.route.snapshot.url[1].path === 'direct') {
      this.aufgabeId = this.route.snapshot.url[2].path;
      this.filterString += ` and id eq ${this.aufgabeId} or original.id eq ${this.aufgabeId} `;
      this.getAufgabe().then(result => {
        if (result) {
          this.aufgabenService.currentAufgabe = result;
          this.currentAufgabe = result;
          this.initAufgabe();
        }
      });
    }
    else {
      this.aufgabeId      = this.route.snapshot.url[1].path;
      this.currentAufgabe = this.aufgabenService.currentAufgabe;
      this.initAufgabe();
    }
  }

  ngOnInit(): void {

    this.successModal = new window.bootstrap.Modal(
        document.getElementById('modalSuccess')
    );
    this.errorModal = new window.bootstrap.Modal(
        document.getElementById('modalError')
    );
    this.rejectModal = new window.bootstrap.Modal(
        document.getElementById('modalReject')
    );
    this.eswSearchModal = new window.bootstrap.Modal(
        document.getElementById('modalESWSearch')
    );
    this.firmenIndexSearchModal = new window.bootstrap.Modal(
        document.getElementById('modalFirmenIndexSearch')
    );
    this.editStandortDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalEditStandortDaten')
    );
  }

  getAufgabe() {
    return new Promise<AufgabeEintragDto | false>((resolve, reject) => {
      this.aufgabenService.getAufgabenList(this.filterString, 1)
          .subscribe(result => {
            if (result) {
              try {
                const aufgabeRaw = JSON.parse(result.aufgabenAsJsonString);
                let aufgabe: AufgabeEintragDto = aufgabeRaw[0];

                if (!aufgabe.azureSearchOriginal) {
                  aufgabe.azureSearchOriginal = [];
                }
                if (!aufgabe.azureSearchESW) {
                  aufgabe.azureSearchESW = [];
                }
                if (!aufgabe.ESW) {
                  aufgabe.ESW = [];
                }

                resolve(aufgabe);

              } catch (error) {
                reject(error);
              }
            }
            else {
              resolve(false);
            }
          },
          err => {
            console.log(err);
            reject(err);
          });
    });
  }

  initAufgabe() {
    if (this.currentAufgabe && this.currentAufgabe.aufgabenpakete[0]) {
      this.currentAufgabePaket = this.currentAufgabe.aufgabenpakete[0];

      this.aufgabeDataSource = [
        {
          aufgabeText:  this.currentAufgabe.aufgabeText,
          aufgabeId:    this.currentAufgabe.id,
          istAufgabe:   true
        }
      ];

      if (this.currentAufgabePaket != undefined) {
        this.pruefdatenSource = [
          {
            aktion:               this.currentAufgabePaket.firma.aktion,
            firmenId:             this.currentAufgabePaket.firma.id,
            firmenname:           this.currentAufgabePaket.firma.name,
            strasseUndHausnummer: this.currentAufgabePaket.firmenstandort.strasseUndHausnummer,
            plz:                  this.currentAufgabePaket.firmenstandort.plz,
            ort:                  this.currentAufgabePaket.firmenstandort.ort,
            crefonummer:          this.currentAufgabePaket.firma.crefonummer,
            beDirectId:           this.currentAufgabePaket.firmenstandort.beDirectId,
            salesforceId:         this.currentAufgabePaket.firmenstandort.salesforceId,
            pcAdressnummer:       this.currentAufgabe.pcAdressnummer,
            nlCode:               this.currentAufgabe.nlCode,
            istAufgabe:           this.currentAufgabePaket.firma.aktion.toLowerCase() != 'ignore',
            source:               this.currentAufgabePaket.firmenstandort.salesforceId ? 'Salesforce' : 'Migration'
          }
        ];

        if (this.currentAufgabePaket && this.currentAufgabePaket.firma && this.currentAufgabePaket.firma.id) {
          this.firmenId = this.currentAufgabePaket.firma.id;
        }

        this.duplikateDataSource            = this.currentAufgabe.azureSearchOriginal.concat(this.currentAufgabe.azureSearchESW);
        this.firmenIndexResultListLength    = 0;

        this.eswSearchResult                    = this.currentAufgabe.ESW;
        this.vorschlaegeESWDataSource           = new MatTableDataSource(this.eswSearchResult);
        this.vorschlaegeESWDataSource.paginator = this.paginator;
        this.vorschlaegeESWDataSource.sort      = this.sort;

        this.tablePruefdatenSource = [
          {
            firmenId:           this.pruefdatenSource[0].firmenId,
            firmenname:         this.pruefdatenSource[0].firmenname,
            crefonummer:        this.pruefdatenSource[0].crefonummer,
            aktion:             this.pruefdatenSource[0].aktion === 'Create' ? 'wird erzeugt' : 'ist vorhanden'
          }
        ];

        this.neuanlageFirmaDataSource = [
          {
            firmenname:             this.currentAufgabePaket.firma.name,
            crefonummer:            this.currentAufgabePaket.firma.crefonummer,
            beDirectId:             this.currentAufgabePaket.firmenstandort.beDirectId,
            salesforceId:           this.currentAufgabePaket.firmenstandort.salesforceId,
            strasseUndHausnummer:   this.currentAufgabePaket.firmenstandort.strasseUndHausnummer,
            plz:                    this.currentAufgabePaket.firmenstandort.plz,
            ort:                    this.currentAufgabePaket.firmenstandort.ort,
            laendercode:            this.currentAufgabePaket.firmenstandort.laendercode,
            pcAdressnummer:         this.currentAufgabePaket.pcAdresse && this.currentAufgabePaket.pcAdresse.pcAdressnummer ?  this.currentAufgabePaket.pcAdresse.pcAdressnummer: ''
          }
        ];

        if (this.currentAufgabePaket.pcAdresse) {
          this.neuanlageFirmaDataSource[0].pcAdressen = [
            {
              pcAdressnummer:       this.currentAufgabePaket.pcAdresse.pcAdressnummer,
              nlCode:               this.currentAufgabePaket.pcAdresse.nlCode,
              originalFirmenname:   this.currentAufgabePaket.pcAdresse.originalFirmenname,
              strasseUndHausnummer: this.currentAufgabePaket.pcAdresse.originalPostanschrift,
            }
          ];
          this.neuanlagePcAdresseDataSource = [
            {
              pcAdressnummer:       this.currentAufgabe.original.pcAdressnummer,
              nlCode:               this.currentAufgabe.original.nlCode,
              originalFirmenname:   this.currentAufgabe.original.name,
              strasseUndHausnummer: this.currentAufgabe.original.strasseUndHausnummer,
              plz:                  this.currentAufgabe.original.plz,
              ort:                  this.currentAufgabe.original.ort
            }
          ];
        }
      }
    }
  }

  selectESWVorschlag(data: VorschlagEswDto) {
    this.formESW.controls['selectESWVorschlag'].setValue(data);
    this.eswSelected = true;
  }

  selectDuplikatVorschlag(data: VorschlagDuplikatDto) {
    this.formDuplikat.controls['selectDuplikatVorschlag'].setValue(data);
    this.duplicateSelected = true;
  }

  back() {
    this.router.navigate(['/aufgaben']).catch();
  }

  markAsResolved(mode:string = '') {
    if (this.currentAufgabePaket) {
      let adaVorschlagAngenommen = false;
      if (mode === 'ada') {
        adaVorschlagAngenommen = true;
      }
      this.aufgabeErledigt = {
        id:                     this.aufgabeId,
        aufgabenTyp:            this.aufgabeTyp,
        erledigtVon:            this.userService.UserName,
        adaVorschlagAngenommen: adaVorschlagAngenommen,
        aufgabenpakete:         [this.currentAufgabePaket],
        original:               this.currentAufgabe.original
      }

      this.aufgabenService.markAsResolved(this.aufgabeErledigt).subscribe({
        next: (response) => {
          this.setAndShowSuccessMessage(mode);
        },
        error: (err) => {
          if (err.status === 500) {
            // Für den Benutzer ggf. relevante Fehlermeldungen
            this.setAndShowErrorMessage(err.error.message);
          }
          else if (err.status === 400) {
            // für den Benutzer irrelevante Fehlermeldungen
            this.setAndShowSuccessMessage(mode);
          }
          else {
            this.setAndShowErrorMessage(err.error.message);
          }
        }
      });
    }
  }

  setAndShowSuccessMessage(mode: string): void {
    this.successMsg = [];
    if (mode === 'duplicate') {
      this.successMsg[0] = 'Der Standort wurde als Duplikat markiert.';

    } else if (mode === 'esw') {
      this.successMsg[0] = 'Der Standort wurde mit ESW-Daten erzeugt.';

    } else if (mode === 'ignore') {
      this.successMsg[0] = 'Der Standort wurde verworfen.';

    } else {
      this.successMsg[0] = 'Der Standort wurde erzeugt.';
    }

    this.successMsg[1] = 'Sie haben diese Aufgabe erledigt.';

    this.successModal.show();
  }

  setAndShowErrorMessage(errorMsg: string): void {
    this.errorMsg     = [];
    this.errorMsg[0]  = errorMsg;
    this.errorMsg[1]  = 'Diese Aufgabe konnte nicht erledigt werden.';

    this.errorModal.show();
  }

  closeSuccessModal() {
    this.successModal.hide();
    this.back();
  }

  closeErrorModal() {
    this.errorModal.hide();
    this.back();
  }

  openEditStandortDatenModal() {
    if (this.currentAufgabePaket) {
      this.editStandortDatenForm.setValue({
        firmenname:           this.currentAufgabePaket.firma.name,
        strasseUndHausnummer: this.currentAufgabePaket.firmenstandort.strasseUndHausnummer,
        plz:                  this.currentAufgabePaket.firmenstandort.plz,
        ort:                  this.currentAufgabePaket.firmenstandort.ort
      });
    }
    this.editStandortDatenModal.show();
  }

  editStandortDaten() {
    if (this.currentAufgabePaket && this.editStandortDatenForm.status === 'VALID') {
      this.currentAufgabePaket.firma.name                           = this.editStandortDatenForm.controls.firmenname.value ?? '';
      this.currentAufgabePaket.firmenstandort.strasseUndHausnummer  = this.editStandortDatenForm.controls.strasseUndHausnummer.value ?? '';
      this.currentAufgabePaket.firmenstandort.plz                   = this.editStandortDatenForm.controls.plz.value ?? '';
      this.currentAufgabePaket.firmenstandort.ort                   = this.editStandortDatenForm.controls.ort.value ?? '';

      this.editStandortDatenModal.hide();

      this.markAsResolved('ada');
    }
  }

  closeEditStandortDatenModal() {
    this.editStandortDatenModal.hide();
  }


  selectDuplikatVorschlagAsAufgabenpaket() {
    if (this.currentAufgabePaket && this.currentAufgabe) {
      const currentDuplikatVorschlag = this.formDuplikat.controls['selectDuplikatVorschlag'].value;
      const currentOriginal          = this.currentAufgabe.original;

      let firmaAktion           = 'Ignore';
      let firmenstandortAktion  = 'Create';
      let pcAdresseAktion       = 'Create';

      let adresskauf = false;

      if (currentDuplikatVorschlag.firmenstandorteId) {
        if ( ! currentOriginal.salesforceId && ! currentOriginal.pcAdressnummer) { // Adresskauf
          adresskauf = true;
          firmenstandortAktion  = 'Ignore';
          pcAdresseAktion       = 'Ignore';

        } else {
          if (currentOriginal.salesforceId) { // aus Salesforce
            firmenstandortAktion  = 'Create';
            pcAdresseAktion       = 'Ignore';
          }
          else if (currentOriginal.pcAdressnummer) { // aus Migration
            firmenstandortAktion  = 'Ignore';
            pcAdresseAktion       = 'Ignore';
          }
        }
      }

      this.currentAufgabePaket.firma.aktion                 = firmaAktion;
      this.currentAufgabePaket.firma.id                     = currentDuplikatVorschlag.firmenId;
      this.currentAufgabePaket.firma.name                   = currentDuplikatVorschlag.firmenname;
      this.currentAufgabePaket.firma.crefonummer            = currentDuplikatVorschlag.crefonummer;
      this.currentAufgabePaket.firma.webseiteHomepage       = currentDuplikatVorschlag.webseiteHomepage;
      if ( ! adresskauf) {
        this.currentAufgabePaket.firma.branchencodeWz1979     = currentOriginal.branchencodeWz1979;
        this.currentAufgabePaket.firma.lieferantVonBranche    = currentOriginal.lieferantVonBranche;
        this.currentAufgabePaket.firma.branchenzuschlag       = currentOriginal.branchenzuschlag;
        this.currentAufgabePaket.firma.psKundenstatus         = currentOriginal.psStatusCode;
        this.currentAufgabePaket.firma.istArbeitsagentur      = currentOriginal.istArbeitsagentur;
        this.currentAufgabePaket.firma.istWettbewerber        = currentOriginal.istWettbewerber;
        this.currentAufgabePaket.firma.webseiteJobboerse      = currentOriginal.jobboerselink;
      }

      this.currentAufgabePaket.firmenstandort.aktion                        = firmenstandortAktion;
      this.currentAufgabePaket.firmenstandort.id                            = currentDuplikatVorschlag.firmenstandorteId;
      this.currentAufgabePaket.firmenstandort.salesforceId                  = currentDuplikatVorschlag.salesforceId;
      this.currentAufgabePaket.firmenstandort.strasseUndHausnummer          = currentDuplikatVorschlag.strasseUndHausnummer;
      this.currentAufgabePaket.firmenstandort.plz                           = currentDuplikatVorschlag.plz;
      this.currentAufgabePaket.firmenstandort.ort                           = currentDuplikatVorschlag.ort;
      this.currentAufgabePaket.firmenstandort.laendercode                   = currentDuplikatVorschlag.land;
      this.currentAufgabePaket.firmenstandort.beDirectId                    = currentDuplikatVorschlag.beDirectId;
      if ( ! adresskauf) {
        this.currentAufgabePaket.firmenstandort.telefon                       = currentOriginal.telefon;
        this.currentAufgabePaket.firmenstandort.fax                           = currentOriginal.fax;
        this.currentAufgabePaket.firmenstandort.email                         = currentOriginal.email;
        this.currentAufgabePaket.firmenstandort.betriebsgroesse               = currentOriginal.betriebsgroesse;
        this.currentAufgabePaket.firmenstandort.betriebsgroesseGewerblich     = currentOriginal.betriebsgroesseGewerblich;
        this.currentAufgabePaket.firmenstandort.betriebsgroesseKaufmaennisch  = currentOriginal.betriebsgroesseKaufmaennisch;
        this.currentAufgabePaket.firmenstandort.hatKantine                    = currentOriginal.hatKantine;
        this.currentAufgabePaket.firmenstandort.psStatusCode                  = currentOriginal.psStatusCode;
      }

      if (this.currentAufgabePaket.pcAdresse) {
        this.currentAufgabePaket.pcAdresse.aktion                 = pcAdresseAktion;
        this.currentAufgabePaket.pcAdresse.originalFirmenname     = currentOriginal.name;
        this.currentAufgabePaket.pcAdresse.originalPostanschrift  = currentOriginal.strasseUndHausnummer;
        if ( ! adresskauf) {
          this.currentAufgabePaket.pcAdresse.pcAdressnummer         = currentOriginal.pcAdressnummer;
          this.currentAufgabePaket.pcAdresse.nlCode                 = currentOriginal.nlCode;
          this.currentAufgabePaket.pcAdresse.unternehmenKuerzel     = currentOriginal.unternehmensKuerzel;
          this.currentAufgabePaket.pcAdresse.originalErstelltAm     = currentOriginal.originalErstelltAm;

        }
      }
      this.markAsResolved('duplicate');
    }
  }

  selectESWVorschlagAsAufgabenpaket() {
    if (this.currentAufgabePaket && this.currentAufgabe) {
      const currentESWVorschlag = this.formESW.controls['selectESWVorschlag'].value;
      const currentOriginal     = this.currentAufgabe.original;

      let firmaAktion           = 'Create';
      let firmenstandortAktion  = 'Create';
      let pcAdresseAktion       = 'Create';

      if ( ! currentESWVorschlag.crefonummer) {
        currentESWVorschlag.crefonummer = null;
      }

      this.currentAufgabePaket.firma.aktion                 = firmaAktion;
      this.currentAufgabePaket.firma.id                     = undefined;
      this.currentAufgabePaket.firma.name                   = currentESWVorschlag.name;
      this.currentAufgabePaket.firma.crefonummer            = currentESWVorschlag.crefonummer;
      this.currentAufgabePaket.firma.webseiteHomepage       = currentESWVorschlag.webseiteHomepage;
      this.currentAufgabePaket.firma.branchencodeWz1979     = currentOriginal.branchencodeWz1979;
      this.currentAufgabePaket.firma.branchencodeWz2008     = currentESWVorschlag.branchencodeWz2008 ? currentESWVorschlag.branchencodeWz2008 : currentOriginal.branchencodeWz2008;
      this.currentAufgabePaket.firma.lieferantVonBranche    = currentOriginal.lieferantVonBranche;
      this.currentAufgabePaket.firma.branchenzuschlag       = currentOriginal.branchenzuschlag;
      this.currentAufgabePaket.firma.psKundenstatus         = currentOriginal.psStatusCode;
      this.currentAufgabePaket.firma.istArbeitsagentur      = currentOriginal.istArbeitsagentur;
      this.currentAufgabePaket.firma.istWettbewerber        = currentOriginal.istWettbewerber;
      this.currentAufgabePaket.firma.webseiteJobboerse      = currentOriginal.jobboerselink;

      this.currentAufgabePaket.firmenstandort.aktion                        = firmenstandortAktion;
      this.currentAufgabePaket.firmenstandort.id                            = undefined;
      this.currentAufgabePaket.firmenstandort.strasseUndHausnummer          = currentESWVorschlag.strasseUndHausnummer;
      this.currentAufgabePaket.firmenstandort.plz                           = currentESWVorschlag.plz;
      this.currentAufgabePaket.firmenstandort.ort                           = currentESWVorschlag.ort;
      this.currentAufgabePaket.firmenstandort.laendercode                   = currentESWVorschlag.land ? currentESWVorschlag.land : currentESWVorschlag.laendercode;
      this.currentAufgabePaket.firmenstandort.telefon                       = currentESWVorschlag.telefon;
      this.currentAufgabePaket.firmenstandort.fax                           = currentESWVorschlag.fax;
      this.currentAufgabePaket.firmenstandort.email                         = currentESWVorschlag.email;
      this.currentAufgabePaket.firmenstandort.betriebsgroesse               = currentESWVorschlag.betriebsgroesse;
      this.currentAufgabePaket.firmenstandort.betriebsgroesseGewerblich     = currentOriginal.betriebsgroesseGewerblich;
      this.currentAufgabePaket.firmenstandort.betriebsgroesseKaufmaennisch  = currentOriginal.betriebsgroesseKaufmaennisch;
      this.currentAufgabePaket.firmenstandort.hatKantine                    = currentOriginal.hatKantine;
      this.currentAufgabePaket.firmenstandort.psStatusCode                  = currentOriginal.psStatusCode;
      this.currentAufgabePaket.firmenstandort.beDirectId                    = currentESWVorschlag.beDirectId;

      if (this.currentAufgabePaket.pcAdresse) {
        this.currentAufgabePaket.pcAdresse.aktion                 = pcAdresseAktion;
        this.currentAufgabePaket.pcAdresse.pcAdressnummer         = currentOriginal.pcAdressnummer;
        this.currentAufgabePaket.pcAdresse.nlCode                 = currentOriginal.nlCode;
        this.currentAufgabePaket.pcAdresse.unternehmenKuerzel     = currentOriginal.unternehmensKuerzel;
        this.currentAufgabePaket.pcAdresse.originalFirmenname     = currentOriginal.name;
        this.currentAufgabePaket.pcAdresse.originalPostanschrift  = currentOriginal.strasseUndHausnummer;
        this.currentAufgabePaket.pcAdresse.originalErstelltAm     = currentOriginal.originalErstelltAm;
      }

      this.markAsResolved('esw');
    }
  }

  openESWSucheModal() {
    this.eswSearchModal.show();
  }

  openFirmenIndexSucheModal() {
    this.firmenIndexSearchModal.show();
  }

  eswSuche() {
    this.eswSearchString = '';
    if (this.eswSucheForm.controls['firmenname']?.value) {
      this.eswSearchString += `&name=${this.eswSucheForm.controls['firmenname']?.value}`;
    }
    if (this.eswSucheForm.controls['strasse']?.value) {
      this.eswSearchString += `&strasseUndHausnummer=${this.eswSucheForm.controls['strasse']?.value}`;
    }
    if (this.eswSucheForm.controls['plz']?.value) {
      this.eswSearchString += `&plz=${this.eswSucheForm.controls['plz']?.value}`;
    }
    if (this.eswSucheForm.controls['ort']?.value) {
      this.eswSearchString += `&ort=${this.eswSucheForm.controls['ort']?.value}`;
    }

    this.searchESW();
  }

  firmenIndexSuche() {
    this.firmenIndexSearchCriteriaSearch = '';
    this.firmenIndexSearchCriteriaSearchField = '';

    if (this.firmenIndexSucheForm.controls['firmenname']?.value) {
      this.firmenIndexSearchCriteriaSearch = this.firmenIndexSucheForm.controls['firmenname']?.value;
      this.firmenIndexSearchCriteriaSearchField = 'firmenname';
    }
    if (this.firmenIndexSucheForm.controls['strasse']?.value) {
      this.firmenIndexSearchCriteriaSearch = this.firmenIndexSucheForm.controls['strasse']?.value;
      this.firmenIndexSearchCriteriaSearchField = 'strasseUndHausnummer';
    }
    if (this.firmenIndexSucheForm.controls['plz']?.value) {
      this.firmenIndexSearchCriteriaSearch = this.firmenIndexSucheForm.controls['plz']?.value;
      this.firmenIndexSearchCriteriaSearchField = 'plz';
    }
    if (this.firmenIndexSucheForm.controls['ort']?.value) {
      this.firmenIndexSearchCriteriaSearch = this.firmenIndexSucheForm.controls['ort']?.value;
      this.firmenIndexSearchCriteriaSearchField = 'ort';
    }

    this.searchFirmenIndex();
  }

  resetESWSuche() {
    this.eswSucheForm.controls['firmenname'].setValue('');
    this.eswSucheForm.controls['strasse'].setValue('');
    this.eswSucheForm.controls['plz'].setValue('');
    this.eswSucheForm.controls['ort'].setValue('');

    this.eswSearchModal.hide();
  }

  resetFirmenIndexSuche() {
    this.firmenIndexSucheForm.controls['firma'].setValue('');
    this.firmenIndexSucheForm.controls['firmenstandort'].setValue('');

    this.firmenIndexSearchModal.hide();
  }

  searchESW() {
    if (this.eswSearchString) {
      this.aufgabenService.getESWList(this.eswSearchString)
          .subscribe(result => {
            if (result) {
              this.eswSearchResult = [...new Set(result)];
              let filteredVorschlaege:VorschlagEswDto[] = [];
              for (const vorschlag of this.eswSearchResult) {
                if ( ! filteredVorschlaege.find(i => i.crefonummer === vorschlag.crefonummer)
                    &&  ! filteredVorschlaege.find(i => i.beDirectId === vorschlag.beDirectId)) {
                  filteredVorschlaege.push(vorschlag);
                }
              }
              this.eswSearchResult = filteredVorschlaege;
              this.vorschlaegeESWDataSource = new MatTableDataSource(this.eswSearchResult);
            }
            else {
              this.vorschlaegeESWDataSource = new MatTableDataSource();
            }
            this.vorschlaegeESWDataSource.paginator = this.paginator;
            this.vorschlaegeESWDataSource.sort      = this.sort;

            this.eswSearchModal.hide();
      });
    }
  }

  searchFirmenIndex() {
    let pageSize = 100;
    let skip = 0;
    //let resultList: TableElement[] = [];
    let resultList: any = [];
    let observableResponse = new Observable<FirmenstandorteIndexResponseDto>();

    if (this.firmenIndexSucheForm.controls['firma']?.value && !this.firmenIndexSucheForm.controls['firmenstandort']?.value) {
      observableResponse = this.firmenstandorteService
          .getFirmenstandorte(`${this.firmenIndexSucheForm.controls['firma']?.value}${this.searchSpecialCharacterFirma}`,
              this.firmaFieldsString, this.searchModeFirma, this.queryTypeFirma,
              this.firmaOrderByString, pageSize, skip, true, this.filterString)
    }
    else if (!this.firmenIndexSucheForm.controls['firma']?.value && this.firmenIndexSucheForm.controls['firmenstandort']?.value) {
      observableResponse = this.firmenstandorteService
          .getFirmenstandorte(`${this.firmenIndexSucheForm.controls['firmenstandort']?.value}${this.searchSpecialCharacterFirmenstandort}`,
              this.firmenstandortFieldsString, this.searchModeFirmenstandort, this.queryTypeFirmenstandort,
              this.firmenstandortOrderByString, pageSize, skip, true, this.filterString)
    }
    else if (this.firmenIndexSucheForm.controls['firma']?.value && this.firmenIndexSucheForm.controls['firmenstandort']?.value) {
      observableResponse = forkJoin([
        this.firmenstandorteService
            .getFirmenstandorte(`${this.firmenIndexSucheForm.controls['firma']?.value}${this.searchSpecialCharacterFirma}`,
                this.firmaFieldsString, this.searchModeFirma, this.queryTypeFirma,
                this.firmaOrderByString, pageSize, skip, true, this.filterString),
        this.firmenstandorteService
            .getFirmenstandorte(`${this.firmenIndexSucheForm.controls['firmenstandort']?.value}${this.searchSpecialCharacterFirmenstandort}`,
                this.firmenstandortFieldsString, this.searchModeFirmenstandort, this.queryTypeFirmenstandort,
                this.firmenstandortOrderByString, pageSize, skip, true, this.filterString),
      ]).pipe(
          map(([a, b]) => {
            return {
              '@odata.count': a['@odata.count'] + b['@odata.count'],
              value: a.value.concat(b.value),
            }
          })
      )
    }

    observableResponse.pipe(
        map(result => {
          this.firmenIndexResultListLength = result['@odata.count'];
          return result.value;
        }),
    )
        .subscribe(response => {
          if (response) {
            response.forEach((firmenstandort: FirmenstandorteIndexFirmenstandortDto) => {
              let result: TableElement = {
                ...firmenstandort,
              };
              resultList.push(result);
            });
            this.vorschlaegeFirmenIndexDataSource = new MatTableDataSource(resultList);
            this.vorschlaegeFirmenIndexDataSource.paginator = this.paginatorFI;
            this.vorschlaegeFirmenIndexDataSource.sort      = this.sort;
            this.firmenIndexSearchModal.hide();
          }
          else {
            this.vorschlaegeFirmenIndexDataSource = new MatTableDataSource();
            this.firmenIndexSearchModal.hide();
          }
        });
  }

  openRejectDialog() {
    this.rejectModal.show();
  }

  closeRejectModal() {
    this.rejectModal.hide();
  }

  rejectStandort() {
    this.rejectModal.hide();

    if (this.currentAufgabePaket && this.currentAufgabe) {
      this.currentAufgabePaket.firma.aktion           = 'Ignore';
      this.currentAufgabePaket.firmenstandort.aktion  = 'Ignore';
      if (this.currentAufgabePaket.pcAdresse) {
        this.currentAufgabePaket.pcAdresse.aktion = 'Ignore';
      }
      this.markAsResolved('ignore');
    }
  }

  sortData(data: any) {
    data.sort = this.sort;
  }
}
